export default [
	{
		title: 'K-1',
		format: 'k_1'
	},
	{
		title: '2-3',
		format: '2_3'
	},
	{
		title: '4-5',
		format: '4_5'
	},
	{
		title: '6+',
		format: '6+'
	},
    {
		title: 'NEW Middle School 2023+',
		format: 'ms'
	}
]
